module.exports = __webpack_public_path__ + "static/img/byconcept-thumb.ceb9bc7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-thumb.webp
// module id = 30
// module chunks = 0